import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'finishStyle',
  title: 'Finish Style',
  type: 'object',
  fields: [
    defineField({
      name: 'type',
      title: 'Type',
      type: 'string',
      options: {
        list: [
          { title: 'Background Color', value: 'backgroundColor' },
          { title: 'Background Image', value: 'backgroundImage' },
        ],
      },
      initialValue: 'backgroundColor',
      validation: (rule: any) => rule.required(),
    }),
    defineField({
      name: 'value',
      title: 'Value',
      type: 'string',
      initialValue: '#000000',
      validation: (rule: any) => rule.required(),
    }),
  ],
})